import client from "../utils/client";

//  ***GET***
const fetchAllPicks = async (props) => {
  const { user_id, contest_id } = props;

  const url = `/api/user_picks_full`;
  const response = await client().get(url, {
    params: {
      contest_id,
      user_id,
    },
  });
  return response;
};

const fetchKOPicksSimple = async (props) => {
  const { user_id, contest_id } = props;

  const url = `/api/round_selections`;
  const response = await client().get(url, {
    params: {
      contest_id,
      user_id,
    },
  });
  return response;
};

//  ***PUT***
const updateGroupPicks = async (props) => {
  const { user_id, contest_id, group_name, rankings } = props;

  const url = `/api/group_ranking`;
  const response = await client().put(url, {
    contest_id,
    user_id,
    group_name,
    rankings,
  });
  return response;
};

const updateThirdPlaceGroupPicks = async (props) => {
  const { user_id, contest_id, rankings } = props;

  const url = `/api/third_place_ranking`;
  const response = await client().put(url, {
    contest_id,
    user_id,
    rankings,
  });
  return response;
};

const updateKOPicks = async (props) => {
  const { user_id, contest_id, team_number, round_name } = props;

  const roundNameMap = {
    round32: "R32",
    round16: "R16",
    quarterFinal: "QF",
    semiFinal: "SF",
    finalists: "FIN",
    final: "F",
    thirdPlace: "3rd",
  };

  const url = `/api/ko_simple_pick`;
  const response = await client().put(url, {
    contest_id,
    user_id,
    team_number,
    round_name: roundNameMap[round_name],
  });
  return response;
};

// Per-MATCH knockout winner pick (the bracket Picks page). Distinct from
// updateKOPicks above, which writes the per-TEAM advancement model via
// /api/ko_simple_pick. This hits /api/ko_picks, which records the winner on the
// match in user_knockout_picks, mirrors it into user_knockout_simple, and
// recalculates status — all in one call.
const updateKOMatchPick = async (props) => {
  const { user_id, contest_id, match_number, winner_team_number } = props;

  const url = `/api/ko_picks`;
  const response = await client().put(url, {
    contest_id,
    user_id,
    match_number,
    winner_team_number,
  });
  return response;
};

const updateTiebreakerAnswer = async (props) => {
  const { user_id, contest_id, tiebreaker_answer } = props;

  const url = `/api/tiebreaker`;
  const response = await client().put(url, {
    contest_id,
    user_id,
    tiebreaker_answer,
  });
  return response;
};

const submitPicks = async (props) => {
  const { user_id, contest_id } = props;

  const url = `/api/submit_picks`;
  const response = await client().put(url, {
    contest_id,
    user_id,
  });
  return response;
};

export {
  fetchAllPicks,
  fetchKOPicksSimple,
  updateGroupPicks,
  updateKOPicks,
  updateKOMatchPick,
  updateThirdPlaceGroupPicks,
  updateTiebreakerAnswer,
  submitPicks,
};
